/* eslint-disable camelcase */
/* eslint-disable no-alert */
import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import firebase from 'firebase/app'
import { Popup, Label, Segment, Table, Button } from 'semantic-ui-react'
import styled from 'styled-components'
import HasuraOrderActions from '../../reducers/hasuraOrderReducer'

import DateRangeField from './components/ExpressCODDateField'
import timeFromNow from './components/TimeFromNow'

import utils from '../../utils/order'
import Hasura from '../../config/hasura'

const Price = styled.div`
  font-weight: bold;
  color: rgb(208, 62, 62);
`

class RefundReport extends React.PureComponent {
  downloadLinkRef = React.createRef()

  state = {
    startFrom: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
    loadingIds: [],
    refunded: false,
    downloadUrl: '',
    downloading: false,
  }

  onDownloadClick = async () => {
    const { orders } = this.props

    if (orders) {
      const arrangeData = this.arrangeData(orders)
      const csvString = this.generateCSV(arrangeData)
      const snapshot = await this.uploadFile(csvString)
      this.downloadFile(snapshot)
    }
  }

  arrangeData = data => {
    return data.map(order => {
      const { customerName, customerTel, createdAt, payments } = order
      const { provider, amount } = payments[0]

      return [
        customerName,
        customerTel,
        provider,
        amount,
        moment(createdAt).format('DD-MM-YYYY') + '-' + moment(createdAt).format('HH:mm a'),
      ]
    })
  }

  generateCSV = data => {
    const header = ['Customer Name', 'Customer Tel', 'Provider', 'Amount', 'Date']
    let csvString = ''

    csvString = csvString.concat(`${header.join(', ')} \n`)
    csvString = csvString.concat(`${data.join('\n')} \n`)

    return csvString
  }

  uploadFile = async csvString => {
    const storage = firebase
      .storage()
      .ref()
      .child(`report/refund.csv`)

    this.setState({ downloading: true })

    return storage.putString(csvString.toString())
  }

  downloadFile = snapshot => {
    const self = this
    snapshot.ref.getDownloadURL().then(downloadUrl => {
      self.setState({ downloading: false, downloadUrl }, () => {
        self.downloadLinkRef.click()
      })
    })
  }

  setStateAsync = state => new Promise(resolve => this.setState(state, resolve))

  getOrderByDate = () => {
    const { getRefundOrders } = this.props
    const { startFrom, endAt, refunded } = this.state

    getRefundOrders(startFrom, endAt, refunded)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  updateRefundedToHasura = async (id, refundedAt) => {
    try {
      const query = `
        mutation {
          update_orders(
            where: {id: {_eq: "${id}"}},
            _set: {refunded: true, refunded_at: ${refundedAt}}
          ) {
            affected_rows
          }
        }
      `
      await Hasura.execute(query)
    } catch (error) {
      alert(error.message)
    }
  }

  onRefund = async order => {
    try {
      const { setSingleRefundOrder } = this.props

      await this.setStateAsync(({ loadingIds }) => ({ loadingIds: loadingIds.concat(order.id) }))

      const orderPath = `orders/${order.firebase_key}`
      const now = Date.now()
      const updates = {}

      updates[`${orderPath}/refunded`] = true
      updates[`${orderPath}/refunded_at`] = now

      await firebase
        .database()
        .ref()
        .update(updates)
      await this.updateRefundedToHasura(order.id, now)

      await this.setStateAsync(({ loadingIds }) => ({ loadingIds: loadingIds.filter(id => id !== order.id) }))

      const data = { ...order, refunded: true, refunded_at: now }

      setSingleRefundOrder({ data })
    } catch (e) {
      alert(e.message)
    }
  }

  renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={5} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  renderPaidPopup = ({ refunded_at: refundedAt }) => (
    <Popup
      trigger={
        <Label
          content="Paid"
          color="green"
          style={{ cursor: 'pointer', padding: '.78571429em 1.5em .78571429em', fontSize: '.78571429rem' }}
        />
      }
      position="top left"
      hideOnScroll
      wide="very"
      on="click"
      content={refundedAt ? timeFromNow(refundedAt) : 'N/A'}
    />
  )

  renderRow = order => {
    const { loadingIds } = this.state
    const {
      id,
      status,
      refunded,
      subtotal,
      createdAt,
      customerTel,
      deliveryFee,
      dynamicFees,
      customerName,
      merchantVatRate,
      deliveryDiscount,
      promotionDiscount,
      promotionCostSharing,
      voucherDiscountAmount,
      payments: [{ amount, provider }],
    } = order

    const customerGrandTotal = utils.calculateCustomerGrandTotal({
      subtotal,
      deliveryFee,
      dynamicFees,
      merchantVatRate,
      deliveryDiscount,
      promotionDiscount,
      promotionCostSharing,
      voucherDiscountAmount,
    })

    const loading = loadingIds.includes(order.id)
    const refundAmount = status === 'delivered' ? amount - customerGrandTotal : amount

    return (
      <Table.Row key={id}>
        <Table.Cell textAlign="center">{timeFromNow(createdAt)}</Table.Cell>
        <Table.Cell textAlign="center">{customerName}</Table.Cell>
        <Table.Cell textAlign="center">{customerTel}</Table.Cell>
        <Table.Cell textAlign="center">{provider}</Table.Cell>
        <Table.Cell textAlign="center">
          <Price>$ {Number(refundAmount).toFixed(2)}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          {refunded ? (
            this.renderPaidPopup(order)
          ) : (
            <Button
              size="mini"
              content="Pay Now"
              loading={loading}
              disabled={loading}
              onClick={() => this.onRefund(order)}
            />
          )}
        </Table.Cell>
      </Table.Row>
    )
  }

  onDateChange = (field, value) => {
    this.setState({ [field]: value })
  }

  render() {
    const { startFrom, endAt, refunded, downloadUrl, downloading } = this.state
    const { orders, loading } = this.props

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onDateChange={this.onDateChange}
            refunded={refunded}
            onRefundChange={() => this.setState({ refunded: !refunded })}
          />
          <Button
            disabled={orders.length === 0}
            loading={downloading}
            onClick={this.onDownloadClick}
            style={{ marginLeft: 10 }}
          >
            Download
          </Button>
          <a
            href={downloadUrl}
            ref={ref => {
              this.downloadLinkRef = ref
            }}
            style={{ display: 'none' }}
          />
          <div style={{ marginBottom: 15 }} />

          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>DateTime</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Customer Name</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Customer Tel</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Provider</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Amount</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {orders.length > 0 ? orders.map(this.renderRow) : this.renderNoDataRow()}
            </Table.Body>
          </Table>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ hasuraOrders }) => ({
  orders: Object.values(hasuraOrders.refundOrders),
  loading: hasuraOrders.refundOrderLoading,
})

const mapDispatch = {
  getRefundOrders: HasuraOrderActions.getRefundOrders,
  setSingleRefundOrder: HasuraOrderActions.setSingleRefundOrder,
}

export default connect(
  mapState,
  mapDispatch
)(RefundReport)



// WEBPACK FOOTER //
// ./src/containers/reports/refund.js